// API
var UnsubscribeReason = require('../../../topics/topics').UnsubscribeReason;

// Internal
var TopicIdSerialiser = require('topics/details/topic-id-serialiser');
var UnsubscriptionNotification = require('./unsubscription-notification');
var ByteEncodedEnumSerialiser = require('serialisers/byte-encoded-enum-serialiser');

module.exports = {
    read : function(input) {
        var id = TopicIdSerialiser.read(input);
        var reason = ByteEncodedEnumSerialiser.read(input, UnsubscribeReason);
        
        return new UnsubscriptionNotification(id, reason);
    },
    write : function(out, notification) {
        TopicIdSerialiser.write(out, notification.id);
        ByteEncodedEnumSerialiser.write(out, notification.reason);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/unsubscription-notification/unsubscription-notification-serialiser.js
// module id = 1053
// module chunks = 1